export const LESSON_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
};

export const LESSON_PERMISSIONS = {
  VIEW: "lesson_plan.view",
  // Can see every teacher's lesson plans
  VIEW_ALL: "lesson_plan.view_all",
};

export const STATUS_FILTER_OPTIONS = [
  { id: LESSON_STATUS.PENDING, name: "Pending" },
  { id: LESSON_STATUS.COMPLETED, name: "Completed" },
];

export const SORT_ORDER_OPTIONS = [
  { id: "asc", name: "Lesson date: oldest first" },
  { id: "desc", name: "Lesson date: newest first" },
];

export const ALL_PLANS_PER_PAGE = 20;
// The weekly planner loads a whole week in one request
export const WEEK_PER_PAGE = 100;

export const SECTION_TYPES = {
  RICH_TEXT: "rich_text",
  BULLET_LIST: "bullet_list",
};

// `tone` maps to the colour tokens in styles/tokens.css (see .lp-tone-* in LessonPlanner.css)
export const PHASES = [
  { key: "engage", label: "Engage", defaultDuration: 5, tone: "primary" },
  { key: "explore_explain", label: "Explore & Explain", defaultDuration: 18, tone: "accent" },
  { key: "wrap_up", label: "Wrap-up", defaultDuration: 7, tone: "success" },
];

// Rotated per subject so each subject keeps the same accent colour
export const SUBJECT_TONES = ["danger", "warning", "info", "accent", "brand", "success", "link"];


